import React from 'react';
import { useTheme } from '@mui/material/styles';

import { Stack, Typography } from 'common/components/material';

import { ObjectiveResponse } from '../types/objective.type';
import ObjectiveCard from './objective-card.component';

type ObjectiveListProps = {
  objectives: ObjectiveResponse[] | undefined;
  isLoading?: boolean;
  emptyMessage?: string;
  showCategoryAndType?: boolean;
  showOwner?: boolean;
  readOnly?: boolean;
  onNavigate?: () => void;
};

const ObjectiveList: React.FC<ObjectiveListProps> = ({
  objectives,
  isLoading = false,
  emptyMessage = 'No objectives yet.',
  showCategoryAndType = true,
  showOwner = false,
  readOnly = false,
  onNavigate,
}) => {
  const { palette } = useTheme();

  if (isLoading) {
    return (
      <Typography variant="body4" color={palette.Text.Caption}>
        {'Loading objectives...'}
      </Typography>
    );
  }

  if (!objectives?.length) {
    return (
      <Typography variant="body4" color={palette.Text.Caption}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {objectives.map((objective) => (
        <ObjectiveCard
          key={objective.id}
          objective={objective}
          showCategoryAndType={showCategoryAndType}
          showOwner={showOwner}
          readOnly={readOnly}
          onNavigate={onNavigate}
        />
      ))}
    </Stack>
  );
};

export default ObjectiveList;
